/**
 * OrivonAI Section Header System
 *
 * Use <SectionHeader> for H2 headers inside page content.
 * Never use inline styles. Never use font-size above 16px.
 *
 * Example:
 * <SectionHeader
 *   title="My story"
 *   descriptor="Your fertility story — cycles and milestones."
 * />
 */
import React from 'react';
import '../styles/pageHeaders.css';

export default function SectionHeader({ title, descriptor, descriptorStyle }) {
  return (
    <div className="page-header-block">
      <h2 className="section-title">{title}</h2>
      {descriptor ? <p className="section-descriptor" style={descriptorStyle}>{descriptor}</p> : null}
    </div>
  );
}
